import React from 'react';
//import programdata from '../programdata/db.json';
// rrd import
import { useLoaderData, Link } from 'react-router-dom';

// component import
import Footer from '../components/Footer';

const UndergraduatePrograms = () => {
    const programs = useLoaderData();
    console.log("Data:", programs);
  return (
    <div className='course-programs'>
        <h2 className='u-title'>Programs we offer</h2>
        
        {
        programs.undergraduatePrograms.map(program => (
            <div className="pro-link">
                <Link to={program.id.toString()} key={program.id}>
                    <p>{program.program}</p>
                    <p><b>Duration</b>: {program.duration}</p>
                </Link>
            </div>
        ))}
        <Footer />
    </div>
  )
}

export default UndergraduatePrograms

// loader function
export const programsLoader = async () => {
    //const res = await fetch('http://localhost:3000/undergraduatePrograms');
    //const res = programdata;
    //if (!res.ok) {
     //   throw Error("Could not fetch programs");
    //}
    //return programdata;
    //res.json();
    const res = await fetch('/programdata/db.json');

  if (!res.ok) {
    throw Error("Could not fetch programs");
  }

  return await res.json();
}
